
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { Dictionary } from 'vue-router/types/router'
import { Form as ElForm, Input } from 'element-ui'
import { UserModule } from '@/store/modules/user'
import { isValidUsername } from '@/common/utils'
import {
    oidcConfig,
    generateRandomString,
    buildUrlWithParams,
    saveOIDCState,
    saveOIDCNonce
} from '@/common/oidc'

@Component({
    name: 'Login',
    components: {
    }
})
export default class extends Vue {
    private validateUsername = (rule: any, value: string, callback: Function) => {
        if (!isValidUsername(value)) {
            callback(new Error('请输入正确的用户名'))
        } else {
            callback()
        }
    }

    private validatePassword = (rule: any, value: string, callback: Function) => {
        if (value.length < 6) {
            callback(new Error('密码长度不能少于6位数'))
        } else {
            callback()
        }
    }

    private loginForm = {
        username: '',
        password: ''
    }
    private loginRules = {
        username: [{ validator: this.validateUsername, trigger: 'blur' }],
        password: [{ validator: this.validatePassword, trigger: 'blur' }]
    }
    private passwordType = 'password'
    private loading = false
    private oidcLoading = false
    private showDialog = false
    private redirect?: string
    private otherQuery: Dictionary<string> = {}

    @Watch('$route', { immediate: true })
    private onRouteChange(route: Route) {
        // TODO: remove the "as Dictionary<string>" hack after v4 release for vue-router
        // See https://github.com/vuejs/vue-router/pull/2050 for details
        const query = route.query as Dictionary<string>
        if (query) {
            this.redirect = query.redirect
            this.otherQuery = this.getOtherQuery(query)
        }
    }

    mounted() {
        if (this.loginForm.username === '') {
            (this.$refs.username as Input).focus()
        } else if (this.loginForm.password === '') {
            (this.$refs.password as Input).focus()
        }
    }

    private showPwd() {
        if (this.passwordType === 'password') {
            this.passwordType = ''
        } else {
            this.passwordType = 'password'
        }
        this.$nextTick(() => {
            (this.$refs.password as Input).focus()
        })
    }

    private handleLogin() {
        (this.$refs.loginForm as ElForm).validate(async(valid: boolean) => {
            if (valid) {
                this.loading = true
                const result = await UserModule.login(this.loginForm)
                if (result.status === 200) {
                    this.$router.push({
                        path: this.redirect || '/',
                        query: this.otherQuery
                    })
                } else {
                    this.$message({ type: 'error', message: result.message })
                }
                this.loading = false
            } else {
                return false
            }
        })
    }

    private getOtherQuery(query: Dictionary<string>) {
        return Object.keys(query).reduce((acc, cur) => {
            if (cur !== 'redirect') {
                acc[cur] = query[cur]
            }
            return acc
        }, {} as Dictionary<string>)
    }

    /**
     * 处理 OIDC 登录
     * 构造授权 URL 并跳转到 IDP 授权页面
     */
    private handleOIDCLogin() {
        this.oidcLoading = true
        
        try {
            // 1. 生成随机 state（防止 CSRF 攻击）
            const state = generateRandomString(32)
            saveOIDCState(state)
            
            // 2. 生成随机 nonce（防止重放攻击）
            const nonce = generateRandomString(32)
            saveOIDCNonce(nonce)
            
            // 3. 构造授权 URL 参数
            const params: Record<string, string> = {
                client_id: oidcConfig.clientId,
                redirect_uri: oidcConfig.redirectUri,
                response_type: oidcConfig.responseType,
                scope: oidcConfig.scope,
                state: state,
                nonce: nonce
            }
            
            // 4. 构造完整的授权 URL
            const authorizeUrl = buildUrlWithParams(oidcConfig.authorizeEndpoint, params)
            
            // 5. 跳转到 IDP 授权页面
            window.location.href = authorizeUrl
        } catch (error) {
            this.oidcLoading = false
            this.$message({ type: 'error', message: 'OIDC 登录初始化失败，请重试' })
        }
    }
}
